import clsx from 'clsx';
import { memo } from '@wordpress/element';
import { BackdropUI } from './styles/input-control-styles';
import styles from './style.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
function Backdrop({
  disabled = false,
  isBorderless = false
}) {
  return /*#__PURE__*/_jsx(BackdropUI, {
    "aria-hidden": "true",
    className: clsx('components-input-control__backdrop', styles.border, disabled && styles['is-disabled'], isBorderless && styles['is-borderless'])
  });
}
const MemoizedBackdrop = memo(Backdrop);
export default MemoizedBackdrop;